"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockLegalsModule = void 0;
const inversify_1 = require("inversify");
let MockLegalsModule = class MockLegalsModule {
    async retrieveTermsAndConditions() {
        return {
            title: "This is a terms and conditions title",
            lead: "this is a lead",
            version: "0.12.3",
            sections: [
                {
                    body: "this is a terms and conditions body",
                    heading: "this is a terms and conditions heading"
                }
            ]
        };
    }
};
MockLegalsModule = __decorate([
    (0, inversify_1.injectable)()
], MockLegalsModule);
exports.MockLegalsModule = MockLegalsModule;
//# sourceMappingURL=MockLegalsModule.js.map